import {Injectable, Optional} from '@angular/core';
import {DeviceFeature} from '@kion/data-models';
import {HttpClient} from '@angular/common/http';
import {ApiConfig} from '../../../../../api-endpoint/src/lib/api.config';
import {Observable, throwError} from "rxjs";
import {catchError, map} from "rxjs/operators";

interface IResponseItem {
  code: string,
  deliveryTime: number,
  deliveryTimeInDays: number,
  name: string
  sortOrder: number,
  url: string,
  truckHealthManagement: ITruckHealthManagement
}

interface ITruckHealthManagement {
  status: string
}

interface SearchResponse {
  products: IResponseItem[]
}

@Injectable({
  providedIn: 'root'
})
export class LmhSoftwareProductConnectors {

  private readonly _rootUrl: string = '';
  private readonly _baseSite: string = '';

  private route = '/truckhealthmanagement';

  constructor(
    @Optional() apiConfig: ApiConfig,
    private http: HttpClient,
  ) {
    this._rootUrl = apiConfig.rootUrl;
    this._baseSite = apiConfig.baseSite;
  }

  private static transformFromApi(response: IResponseItem): DeviceFeature {
    return {
      classifications: [],
      images: [],
      operatingElement: "",
      summary: "",
      type: "",
      usps: "",
      variantOptions: [],
      ...response,
      id: response.code,
      status: response?.truckHealthManagement?.status
    };
  }

  getAll(serialNumber: string): Observable<DeviceFeature> {
    return this.http.get<IResponseItem>(this.getManyUrl() + '/' + serialNumber).pipe(
      map((response: IResponseItem) => LmhSoftwareProductConnectors.transformFromApi(response)),
      catchError(error => {
        console.error('Load TruckHealthManagement error', error);
        return throwError('TruckHealthManagement could not be loaded!');
      })
    );
  }

  protected getManyUrl() {
    return this._rootUrl + this._baseSite + this.route;
  }

  protected getOneUrl(id: number) {
    return this._rootUrl + this._baseSite + this.route + id;
  }

}
